<template>
  <router-view v-bind:on="title"></router-view>
</template>

<script>
import { mapGetters } from "vuex";
import JQuery from 'jquery'
// eslint-disable-next-line
let $ = JQuery
export default {
  name: "App",

  data: () => ({
    //
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    title () {
      document.title = this.$route.meta.title + ' | Observatorio Regional de la Energía REDEMA'
      return true
    }
  },
};
</script>
